export enum ShipmentTransportOrderEndpoint {
  Base = '/shipments',
  Count = '/count',
  Comments = '/comments',
  Equipments = '/equipments',
  Tos = '/tos',
  TranportOrders = '/transport-orders',
  Summary = '/summary',
  Overview = '/overview',
  Materials = '/materials',
  Map = '/map',
  Milestones = '/milestones',
  Notifications = '/notifications',
  OuterPackages = '/outer-packages',
  PlannedInfos = '/planned-infos',
  StatusHistories = '/load-histories',
  Loads = '/loads',
  Parties = '/parties',
  SapDeliveries = '/sap-deliveries',
}
